import * as actionTypes from '../actions/kenmeiList'

const initialState = {
  branchOffices: [],
  departments: [],
  customers: [],
  list: [],
  listDispPage: [],
  listAllCount: []
}

const kenmeiList = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SYSTEM_INIT:
      const branchOffices = [
        {value: 1, text: 'test'}
      ]
      const departments = [
        {value: 1, text: 'test'}
      ]
      const customers = [
        {value: 1, text: 'test'}
      ]
      return Object.assign({}, state, {
        branchOffices: branchOffices,
        departments: departments,
        customers: customers,
      })
    default:
      return state
  }
}

export default kenmeiList


// WEBPACK FOOTER //
// ./src/reducers/kenmeiList.js